import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import Coverage from "@/components/Coverage";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import SeoText from "@/components/SeoText";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import WhatsAppFloat from "@/components/WhatsAppFloat";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-night-900 text-slate-200 flex items-center justify-center p-6 text-center">
          <div>
            <h1 className="font-display text-3xl uppercase mb-3">Bir sorun oluştu</h1>
            <p className="text-slate-400">
              Yolda kaldıysanız beklemeyin, hemen arayin:{" "}
              <a className="text-brand font-bold text-xl" href="tel:+905392196017" data-testid="error-fallback-call-link">
                0539 219 60 17
              </a>
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative">
        <div className="grain-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <TrustBar />
          <Services />
          <Coverage />
          <WhyUs />
          <Testimonials />
          <Faq />
          <SeoText />
          <Footer />
        </main>
        <MobileBar />
        <WhatsAppFloat />
      </div>
    </ErrorBoundary>
  );
}

export default App;
